import { sections } from "../../common/config";

const { landing, buffer, history, faqs, flavor } = sections.height;

const data = [
  { label: "History", to: (landing + buffer) / 100 },
  { label: "FAQs", to: (landing + buffer + history) / 100 },
  { label: "Cider", to: (landing + buffer + history + faqs) / 100 },
  { label: "Contact", to: (landing + buffer + history + faqs + flavor) / 100 }
];

export default data;